import React, { FC, FormEventHandler, useEffect, useState } from 'react'
import Page from '../components/Page'
import { Link } from 'react-router-dom'
import Form from '../components/Form'
import useAuth from '../hooks/useAuth'
import { isValidationFailedResponse } from '../types'
import Alert from '../components/Alert'
import { logError } from '../store/slices/app'
import { useDispatch } from 'react-redux'

const PasswordEmail: FC = () => {
  const [email, setEmail] = useState('')
  const [alert, setAlert] = useState<undefined | { message: string; type: 'danger' | 'success' }>(undefined)
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const api = useAuth()
  const dispatch = useDispatch()

  const handleSubmit: FormEventHandler<HTMLFormElement> = async (event) => {
    event.preventDefault()
    if (isLoading) return

    setIsLoading(true)
    setAlert(undefined)
    setErrors({})

    try {
      const response = await api.sendResetLinkEmail({ email })

      setAlert({ type: 'success', message: response.data.message })
    } catch (error) {
      dispatch(logError(error))
      if (isValidationFailedResponse(error)) {
        setAlert({ type: 'danger', message: 'There were some errors processing your request.' })
        setErrors(error.response.data.data.params)
      } else {
        setAlert({ type: 'danger', message: 'An unknown error occurred.' })
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Page className="bg-pink">
      <div className="login-wrap min-vh-100 d-flex align-items-center flex-column justify-content-center flex-wrap">
        <div className="container">
          <div className="step-one-wrap">
            <div className="row">
              <div className="col-12">
                <h1 className="text-center">Reset Password</h1>
              </div>
            </div>

            <div className="row justify-content-center align-items-center">
              <div className="col-12 col-lg-5 col-xxl-4">
                <form className="my-3 mt-lg-5" onSubmit={handleSubmit} noValidate>
                  {!!alert && <Alert type={alert.type} msg={alert.message} />}
                  <div className="form-group">
                    <label htmlFor="user_email" className="sr-only">
                      Your Email
                    </label>
                    <input
                      type="email"
                      className="form-control form-control-lg"
                      id="user_email"
                      name="user_email"
                      placeholder="Your Email"
                      value={email}
                      onChange={(event) => setEmail(event.target.value)}
                    />
                    <Form.ValidationError message={errors['email']} />
                  </div>
                  <button disabled={isLoading} type="submit" className="btn btn-secondary btn-block border-0 btn-lg">
                    {isLoading ? <div className="spinner-border text-light mr-2" role="status"></div> : null}
                    <span>Reset</span>
                  </button>
                </form>
                <div className="row">
                  <div className="col pb-lg-5">
                    <Link to="/login/" className="text-secondary float-right">
                      Sign in
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  )
}

export default PasswordEmail
